import {Component, Inject, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {Documents} from "../../dto/Documents";
import {ConfirmationService, MessageService, TreeNode} from "primeng/api";
import {PageDoc} from "../../dto/PageDoc";
import {Table} from "primeng/table";
import {Category} from "../../dto/Category";
import {Post} from "../../dto/Post";
import {PostItem} from "../../dto/PostItem";
import {EditorBO} from "../../dashbord/bo/EditorBO";
import {NgxSuneditorComponent} from "ngx-suneditor";
import {RestBackendService} from "../../service/rest-backend.service";
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalService} from "../../service/global.service";
import {ConfigService} from "../../service/config.service";
import {JalaliDateCalculatorService, PersianNumberService} from "ngx-persian";
import {ItemStyle} from "../../dto/ItemStyle";

@Component({
  selector: 'app-overview-doc',
  templateUrl: './overview-doc.component.html',
  styleUrls: ['./overview-doc.component.css']
})
export class OverviewDocComponent implements OnInit {
  newDoc: Documents = new Documents();
  selectedDoc: Documents = new Documents();
  listDocs: Array<Documents> = new Array<Documents>();
  doc: string = "";
  page: string = "";
  itemEditMode: boolean = false;
  postEditMode: boolean = false;

  constructor(protected restBack: RestBackendService,
              public route: Router,
              public activeRoute: ActivatedRoute,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              public global: GlobalService,
              protected config: ConfigService,
              public jalaliDateCalculatorService: JalaliDateCalculatorService,
              public persianNumberService: PersianNumberService,
              @Inject(LOCALE_ID) public locale: string
  ) {
  }

  ngOnInit(): void {
    this.doc = this.activeRoute.snapshot.paramMap.get("doc") + "";
    this.page = this.activeRoute.snapshot.paramMap.get("page") + "";
    this.getDocList(null);

  }

  //...................Document.....................

  selectDoc(doc: Documents) {
    this.selectedDoc = doc;
    this.getCategoryList(null);
    this.treeMap = new Map<string, TreeNode>();
    this.categoryTree = [];
    this.selectedPage = new PageDoc();
    this.selectedCategory=new Category();
    // this.route.navigate(["dashboard/overview/" + this.selectedDoc.name.replace(" ", "_")]);
    let path ="dashboard/overview/" + this.selectedDoc.name.replace(" ", "_");
    window.history.replaceState(null, "" , path);
  }


  getDocList(table: Table | null) {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/get_docs" +
      "?page=" + (table != null ? table.first / 10 : 0) +
      "&nrpp=" + (table != null ? table.rows : 10) +
      "&id=" + this.newDoc.id +
      "&name=" + this.newDoc.name
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.listDocs = result["entity"];
        if (this.listDocs.length > 0) {
          this.selectedDoc = this.listDocs[0];
          for (let listDoc of this.listDocs) {
            if (listDoc.name.replace(" ", "_") == this.doc) {
              this.selectedDoc = listDoc;
            }
          }

          this.getCategoryList(null);
        }
      } else if (status == 401) {

      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });


  }


  //.............Category.................
  newCategory: Category = new Category();
  selectedCategory: Category = new Category();
  listCategory: Array<Category> = new Array<Category>();
  filteredCategory: Array<Category> = new Array<Category>();
  categoryTree: TreeNode[] = [];
  selectedTree: TreeNode = {};
  deleteKey: string = "0";
  listPage: Array<PageDoc> = new Array<PageDoc>();


  filterCategory(event: any) {
    this.filteredCategory = new Array<Category>();
    for (let category of this.listCategory) {
      if (category.name.indexOf(event.query) > -1) {
        this.filteredCategory.push(category);
      }
    }
  }

  treeMap: Map<string, TreeNode> = new Map<string, TreeNode>()

  getCategoryList(table: Table | null) {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/get_category" +
      "?page=" + (table != null ? table.first / 10 : 0) +
      "&nrpp=" + (table != null ? table.rows : 500) +
      "&id=" + this.newCategory.id +
      "&doc_id=" + this.selectedDoc.id +
      "&name=" + this.newCategory.name
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.listCategory = result["entity"];

// .........................Category............................................
        let first: boolean = true;
        for (let cg of this.listCategory) {


          if (cg.id > 0) {
            var treeGroup: TreeNode = {"data": []};
            treeGroup.key = cg.id + "";
            treeGroup.label = cg.name;
            treeGroup.children = [];
            treeGroup.type = 'CATEGORY';
            if (cg.id == 0) {
              treeGroup.expanded = true
            } else {
              treeGroup.leaf = false;
            }
            treeGroup.selectable = true;
            this.treeMap.set(cg.id + "", treeGroup);
            if (cg.parent == null || cg.parent.id < 1) {
              // @ts-ignore
              this.categoryTree.push(this.treeMap.get(cg.id + ""));
            }
          }
          else {
            this.categoryTree = this.categoryTree.filter(t => t.type != "PAGE");

            for (let p of cg.pageDocs) {
              var treeGroup: TreeNode = {"data": []};
              treeGroup.key = "p_" + p.id;
              treeGroup.label = p.label;
              treeGroup.children = [];
              treeGroup.type = 'PAGE';
              treeGroup.leaf = true;
              treeGroup.selectable = true;
              treeGroup.styleClass = "tree-page-node";
              treeGroup.parent = this.treeMap.get(cg.id + "");
              // this.treeMap.set("p_" + p.id, treeGroup);
              if (cg.parent == null || cg.parent.id < 1) {
                // @ts-ignore
                this.categoryTree.push(treeGroup);
              }
              if (first && (this.page == null || this.page == "null" || this.page == "")) {
                first = false;
                this.page = p.name;
                this.selectedPage = p;
                // this.loadPost(p.id + "");
                // this.route.navigate(["dashboard/overview/" + this.selectedDoc.name.replace(" ", "_") + "/" + p.name.replace(" ", "_")]);
                let path ="dashboard/overview/" + this.selectedDoc.name.replace(" ", "_") + "/" + p.name.replace(" ", "_");
                window.history.replaceState(null, "" , path);
              }
              if (p.name.replace(" ", "_") == this.page) {
                this.selectedPage = p;
                this.selectedTree = treeGroup;
                // this.loadPost(this.selectedPage.id + "");
              }
            }

          }

        }

        for (let cg of this.listCategory) {
          if (cg.id > 0) {
            if (cg.parent != null && cg.parent.id > 0) {
              // @ts-ignore
              this.treeMap.get(cg.id + "").parent = this.treeMap.get(cg.parent.id + "");
              // @ts-ignore
              var find = this.treeMap.get(cg.parent.id + "").children.find(c => c.key == cg.id + '');
              if (this.deleteKey != "0") {
                // @ts-ignore
                this.treeMap.get(cg.parent.id + "").children = this.treeMap.get(cg.parent.id + "").children.filter(ch => ch.key !== this.deleteKey + "")
                this.deleteKey = "0";
              } else if (!find) {
                // @ts-ignore
                this.treeMap.get(cg.parent.id + "").children.push(this.treeMap.get(cg.id + ""));

              } else {
                find.label = cg.name;
              }
            }

          }
        }
// ........................AddPage.....................
        this.listPage = [];
        for (let cg of this.listCategory) {
          for (let pageDoc of cg.pageDocs) {
            this.listPage.push(pageDoc);
          }

          if (cg.id > 0) {
            if (cg.pageDocs.length > 0) {
              // @ts-ignore
              this.treeMap.get(cg.id + "").children = this.treeMap.get(cg.id + "").children.filter(obj => obj.type !== "PAGE");
              for (let p of cg.pageDocs) {
                var treeGroup: TreeNode = {"data": []};
                treeGroup.key = "p_" + p.id;
                treeGroup.label = p.label;
                treeGroup.children = [];
                treeGroup.type = 'PAGE';
                treeGroup.leaf = true;
                treeGroup.selectable = true;
                treeGroup.styleClass = "tree-page-node";
                treeGroup.parent = this.treeMap.get(cg.id + "");
                // @ts-ignore
                this.treeMap.get(cg.id + "").children.push(treeGroup);
                if (first && (this.page == null || this.page == "null" || this.page == "")) {
                  first = false;
                  this.page = p.name;
                  this.selectedPage = p;
                  let path ="dashboard/overview/" + this.selectedDoc.name.replace(" ", "_") + "/" + p.name.replace(" ", "_");
                  window.history.replaceState(null, "" , path);
                }
                if (p.name.replace(" ", "_") == this.page) {
                  this.selectedPage = p;
                  this.selectedTree = treeGroup;
                  // @ts-ignore
                  this.treeMap.get(cg.id + "").expanded = true;
                  // @ts-ignore
                  if (this.treeMap.get(cg.id + "").parent) {
                    // @ts-ignore
                    this.treeMap.get(cg.id + "").parent.expanded = true;
                    // @ts-ignore
                    if (this.treeMap.get(cg.id + "").parent.parent) {
                      // @ts-ignore
                      this.treeMap.get(cg.id + "").parent.parent.expanded = true;
                      // @ts-ignore
                      if (this.treeMap.get(cg.id + "").parent.parent.parent) {
                        // @ts-ignore
                        this.treeMap.get(cg.id + "").parent.parent.parent.expanded = true;
                      }
                    }
                  }


                }


              }
            }
          }
        }
        setTimeout(() => {
          if (this.selectedPage) {
            if (this.selectedTree.parent != null) {
              // @ts-ignore
              this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
            }
            // this.loadPost(this.selectedPage.id + "");
            this.loadPage(this.selectedPage.id+"");
          }
        }, 100);


        // ..........................................................

        // this.categoryTree = this.categoryTree.sort((c1, c2) => {
        //   if (c1.type != "PAGE") {
        //     return 1;
        //   }
        //   if (c2.type != "PAGE") {
        //     return -1;
        //   }
        //   // @ts-ignore
        //   if (c1.key > c2.key) {
        //     return 1;
        //   }
        //   // @ts-ignore
        //   if (c1.key < c2.key) {
        //     return -1;
        //   }
        //   return 0;
        // });
      } else if (status == 401) {

      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
      setTimeout(()=>{
        this.postMenu= new Map<string, string>();
        var elements: HTMLCollectionOf<Element> = document.getElementsByClassName("post-title" );
        for (var j = 0; j < elements.length; j++) {
          // elements[j].setAttribute("style", "");
          this.postMenu.set(elements[j].id,elements[j].children[0].innerHTML);

        }
      },250)
    });
  }


  // ..............................PageDoc...........................
  selectedPage: PageDoc = new PageDoc();
  newPage: PageDoc = new PageDoc();

  nodePageSelect(event: any) {
    if (event.node.type == "PAGE") {
      // @ts-ignore
      this.selectedPage = this.listPage.find(c => "p_" + c.id == event.node.key);
      // this.route.navigate(["dashboard/overview/" + this.selectedDoc.name.replace(" ", "_") + "/" + this.selectedPage.name.replace(" ", "_")]);
      let path ="dashboard/overview/" + this.selectedDoc.name.replace(" ", "_") + "/" + this.selectedPage.name.replace(" ", "_");
      window.history.replaceState(null, "" , path);
      setTimeout(() => {
        if (this.selectedPage) {
          if (this.selectedTree.parent != null) {
            // @ts-ignore
            this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
          }else {
            this.selectedCategory=new Category();
          }
          this.loadPage(this.selectedPage.id + "");
        }
      }, 100);
    } else {
      event.node.expanded = !event.node.expanded;
    }
  }
  postMenu:Map<string,string>= new Map<string, string>();
  loadPage(pageID: string): Promise<string> {
    this.global.progressBar = true;
    this.postMenu= new Map<string, string>();
    var observable = this.restBack.doGet("doc/page/get_pages" +
      "?id=" + pageID
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        let a: Array<PageDoc> = result["entity"];
        if (a.length > 0) {
          this.selectedPage = a[0];
        }
        // this.loadPost(pageID);
        this.codeTabClick();
      } else if (status == 401) {

      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
      setTimeout(() => {
        var elements: HTMLCollectionOf<Element> = document.getElementsByClassName("post-title");
        for (var j = 0; j < elements.length; j++) {
          // elements[j].setAttribute("style", "");
          this.postMenu.set(elements[j].id, elements[j].children[0].innerHTML);

        }
      },200);
      });
    this.activeRoute.fragment.subscribe((fragment: string|null) => {
      if(fragment==null)
        fragment="";
      this.goToFregment(fragment);
    });

    return observable;
  }

  // ......................Post.....................
  newPost: Post = new Post();
  selectedPost: Post = new Post()
  displayItemType: boolean = false;
  itemDialog: Map<string, boolean> = new Map<string, boolean>();
  tempPostItem: PostItem = new PostItem();
  configHeader: string = "";
  configDialog: boolean = false;
  editorBO: EditorBO = new EditorBO();
  postIndex: number = -1;

  private ngxSunEditor: NgxSuneditorComponent | undefined;

  @ViewChild("suneditor") suneditor: NgxSuneditorComponent | undefined;
  activeConfig: number = 1;

  loadPost(pageID: string): Promise<string> {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/get_post_list" +
      "?page=0" +
      "&nrpp=500" +
      "&page_id=" + pageID
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.selectedPage.posts = result["entity"];
        // @ts-ignore
        this.activeRoute.fragment.subscribe((fragment: string) => {
          if (fragment != null) {
            // @ts-ignore
            document.getElementById(fragment).scrollIntoView();
          }
        });

      } else if (status == 401) {

      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });
    return observable;
  }

  selectTypeItemDialog(type: string) {
    this.tempPostItem = new PostItem();
    this.tempPostItem.type = type;
    for (let item of this.selectedPost.postItems) {
      if (item.priority > this.tempPostItem.priority) {
        this.tempPostItem.priority = item.priority;
      }
    }
    this.displayItemType = false;
    this.configDialog = true;

    if (type == "TITLE") {
      this.configHeader = $localize`:@@Title:Title`;
      this.itemDialog.set("TITLE", true);
      this.tempPostItem.style.font_size = "20px";
      this.tempPostItem.style.font_weight = "bold";
      this.tempPostItem.itemAttribute.value = "";

    } else if (type == "TEXT") {
      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditor?.setOptions(this.editorBO.editorOptions);
        this.suneditor ? this.suneditor.content = "" : "";
      }, 10);

      this.configHeader = $localize`:@@Text:Text`;
      this.itemDialog.set("TEXT", true);
      this.tempPostItem.itemAttribute.value = "";

    } else if (type == "CODE") {
      this.configHeader = $localize`:@@Code:Code`;
      this.itemDialog.set("CODE", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-code1";

    } else if (type == "NOTE") {
      this.configHeader = $localize`:@@Note:Note`;
      this.itemDialog.set("NOTE", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-notice1";

    } else if (type == "WARN") {
      this.configHeader = $localize`:@@Warning:Warning`;
      this.itemDialog.set("WARN", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-warning1";

    } else if (type == "TAG") {
      this.configHeader = $localize`:@@Tag:Tag`;
      this.itemDialog.set("TAG", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-tag";

    } else if (type == "DIVIDER") {
      this.configHeader = $localize`:@@Divider:Divider`;
      this.itemDialog.set("DIVIDER", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-title-divider";

    } else if (type == "IMAGE") {
      this.configHeader = $localize`:@@Image:Image`;
      this.itemDialog.set("IMAGE", true);
      this.tempPostItem.itemAttribute.src = "";
    } else if (type == "LIST") {
      this.configHeader = $localize`:@@List:List`;
      this.itemDialog.set("LIST", true);
      this.tempPostItem.itemAttribute.value = "";
    }
    setTimeout(() => {
      this.activeConfig = 0;
    }, 100)


  }


  dragDiv(ev: any) {
    ev.dataTransfer.setData("text", ev.target.id);
  }

  dropDiv(ev: any) {

    ev.preventDefault();
    var data = ev.dataTransfer.getData("text");

    let thisdiv: Element = ev.target;

    if (thisdiv.className.indexOf("post-item") > -1) {
      // @ts-ignore
      document.getElementById(data).ertBefore(thisdiv, null);
    }

  }

  onDragOver(event: Event) {
    event.preventDefault();
  }


  sortItems(post: Post) {
    post.postItems = post.postItems.sort((a, b) => (a.priority > b.priority ? -1 : 1));

  }

  creatPostTag(post: Post): string {
    return post.name.replace(" ", "_");
  }

  creatPostTagLink(post: Post): string {
    return window.location.pathname + "#" + post.name.replace(" ", "_");
  }

  miliSecontToDate(milisecond: number): Date {
    return new Date(milisecond);
  }

  goToFregment(id: string) {
    // @ts-ignore
    document.getElementById(id).scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  }

  creatNavCategoryList():Array<Category> {
    let list:Array<Category> = new Array<Category>();
    if(this.selectedCategory != null && this.selectedCategory.id>0 ) {
      list.push(this.selectedCategory);
      let parent: Category | undefined = this.selectedCategory.parent;
      while (true) {
        if (parent != null) {
          list.push(parent ? parent : new Category());
          if (parent?.parent != null) {
            parent = parent.parent;
          } else {
            break;
          }
        } else {
          break;
        }
      }
    }
    list.reverse();
    return list;

  }

  codeTabClick(){
    setTimeout(()=>{
      try {
        var elements2: HTMLCollectionOf<Element> = document.getElementsByClassName("code-tabs");
        elements2[0].className = elements2[0].className + " active";
        for (var k = 0; k < elements2.length; k++) {
          elements2[k].addEventListener("click", (e) => {
            try {
              // @ts-ignore
              let itemIndex: string = e.target['attributes']['data-mode'].value;


              var el1: HTMLCollectionOf<Element> = document.getElementsByClassName("item-tab-" + itemIndex);
              for (var z = 0; z < el1.length; z++) {
                el1[z].className = el1[z].className.replace(" active", "");
              }
              (e.target as HTMLDivElement).className = (e.target as HTMLDivElement).className + " active";

              // @ts-ignore
              let temp: string = e.target['attributes']['data-value'].value;


              var elements: HTMLCollectionOf<Element> = document.getElementsByClassName("item-body-" + itemIndex);
              for (var j = 0; j < elements.length; j++) {
                elements[j].setAttribute("style", "display: none;");
              }
              var elements2: HTMLCollectionOf<Element> = document.getElementsByClassName(temp);
              for (var j = 0; j < elements2.length; j++) {
                elements2[j].setAttribute("style", "");
              }
            } catch (e) {
            }
          });
        }
      }catch (e) {}

      var elements3: HTMLCollectionOf<Element> = document.getElementsByClassName("item-body-copy");
      for (var k = 0; k < elements3.length; k++) {
        elements3[k].innerHTML = $localize`:@@Copy:Copy`;
        elements3[k].addEventListener("click", (e) => {
          // @ts-ignore
          let val: string = e.target['attributes']['data-mode'].value;
          // @ts-ignore
          this.copyToClipboard(document.getElementById(val).innerText);
          // @ts-ignore
          e.target['innerHTML'] =$localize`:@@Copied:Copied`;
          setTimeout(()=>{
            // @ts-ignore
            e.target['innerHTML'] = $localize`:@@Copy:Copy`;
          },1000*60)

        });
      }
    },200);



  }
  copyToClipboard(text:string) {
    var input = document.body.appendChild(document.createElement("textarea"));
    input.value = text;
    input.focus();
    input.select();
    document.execCommand('copy');
    // @ts-ignore
    input.parentNode.removeChild(input);
  }
  getDirection(): string {
    if (this.locale == "fa") {
      return "rtl";
    } else {
      return "ltr";
    }
  }

  getHost():string {
    return window.location.host
  }

  showItemInPost(post: Post,item:PostItem): string {
    this.selectedPost = post;
    // this.tempPostItem = item;
    return this.creatItemHtml(item,0, true);
  }
  creatItemHtml(item:PostItem,time: number, editMode: boolean): string {
    let innerHtml = "";
    var countItem = this.selectedPost.postItems.length;
    var style = ItemStyle.getStyle(item.style);
    //..............................TITLE............................
    if (item.type == "TITLE") {
      innerHtml = "<h2 class='" + item.itemAttribute.class_style + "'  style=\"" + style + "\" >" + item.itemAttribute.value + "</h2>";
    }
    //........................Text..................................
    else if (item.type == "TEXT") {
      // innerHtml="<h2 style=\""+style+"\" >"+item.attr.value+"</h2>";
      if (!editMode) {
        const textarea: HTMLInputElement = this.suneditor ? this.suneditor.save(false) as HTMLInputElement : new HTMLInputElement();
        item.itemAttribute.value = textarea.value;
      }
      innerHtml = "<div class='sun-editor-editable' style=\"" + style + "\"  >" + item.itemAttribute.value + "</div>";
    }

    //........................TextBox..................................
    else if (item.type == "TEXTBOX") {
      innerHtml = "<div class='sun-editor-editable searchia-docs-textbox " + item.itemAttribute.class_style + "' style=\"" + style + "\"  >";
      if (item.itemAttribute.label.length > 0)
        innerHtml += "<div class='box-title'>" + item.itemAttribute.label + "</div>";
      if (item.itemAttribute.type != "json")
        innerHtml += "<div class='box-value'>" + item.itemAttribute.value + "</div></div>";
      else {
        let t={};
        try {
          t= JSON.parse(item.itemAttribute.value2)
        }catch (e) {
        }
        innerHtml += "<div class='box-value' style='white-space: pre-wrap;font-family: monospace;'>" + JSON.stringify(t, null, 4) + "</div></div>";
      }
    }

    //........................Note..................................
    else if (item.type == "NOTE") {

      innerHtml = "<div style=\"" + style + "\" class='" + item.itemAttribute.class_style + "'>" +
        "<div class='title' >" + item.itemAttribute.type + ":</div><div class='body'>";
      // for (let s of item.itemAttribute.value.split("\n")) {
      //   innerHtml += s + "<br/>";
      // }
      innerHtml += item.itemAttribute.value;
      innerHtml += "</div></div>";
    }

    //........................Tag..................................
    else if (item.type == "TAG") {
      // innerHtml = "";
      for (let s of item.itemAttribute.value.split(",")) {
        innerHtml += "<div style=\"" + style + "\" class='" + item.itemAttribute.class_style + "'>" +
          s +
          "</div>";
      }
    }

    //........................DIVIDER..................................
    else if (item.type == "DIVIDER") {
      innerHtml = "<div style=\"" + style + "\" class='" + item.itemAttribute.class_style + "'>" +
        "</div>";
    }

    //........................Code..................................
    else if (item.type == "CODE") {
      let codeItem:any[]=[];

      codeItem = JSON.parse(item.itemAttribute.value );

      innerHtml = "<div style=\"" + style + ";\" class='" + item.itemAttribute.class_style + "'>" +
        "<div class='codeType'>" + item.itemAttribute.type + "</div> ";
      innerHtml += "<div style='width: 100%;text-align: right;margin-bottom: 10px'>" + item.itemAttribute.description + "</div>";
      let j = 1;
      innerHtml += "<div class='codeTabView ctv-" + (countItem + 1) + "'>";
      if (codeItem[0]!=null && codeItem[0]["title"].length > 0) {
        innerHtml += "<div class='tabs-row'  >";
        for (let itm of codeItem) {
          if (itm["title"].length > 0) {
            innerHtml += "<div class='code-tabs item-tab-" + (countItem + 1) + " cttab-" + (countItem + 1) + "-" + j + "'" +
              " data-value='ctb-" + (countItem + 1) + "-" + j + "' data-mode='" + (countItem + 1) + "' style='cursor: pointer' " +
              ">" + itm["title"] + "</div>";
            j++;
          }
        }
        innerHtml += "</div>";
      }
      let y = 1;
      for (let itm of codeItem) {
        innerHtml += "<div style='display: " + (y == 1 ? "" : "none") + "' class='code-tab-body item-body-" + (countItem + 1) + " ctb-" + (countItem + 1) + "-" + y + "'>";
        innerHtml += "<div id='code-copy-" + (countItem + 1) + "-" + y + "' style='display: none'>" + itm['value'] + "</div>";
        innerHtml += "<div  class=' item-body-copy ' data-mode='code-copy-" + (countItem + 1) + "-" + y + "' >" +
          "</div>";
        let i = 1;
        for (let s of itm["value"].split("\n")) {
          innerHtml += "<div style='display: flex'><div class='number'>" + (i++) + "</div><div class='code'>" + s + "</div></div>";
        }
        innerHtml += "</div>";
        y++;
      }
      innerHtml += "</div></div>";

    } else if (item.type == "LIST") {
      innerHtml = "<div style=\"" + style + ";\" class='searchia-docs-ul ' ><ul class='" + item.itemAttribute.class_style + "'> ";
      let i = 1;
      for (let s of item.itemAttribute.value.split("\n")) {
        innerHtml += "<li>" + s + "</li>";
      }
      innerHtml += "</ul></div>";
    } else if (item.type == "IMAGE") {
      item.itemAttribute.type = "IMAGE";
      item.itemAttribute.value = "IMAGE";

      innerHtml = "<div style=\"" + style + ";\" class='doc-img-div'>  ";

      innerHtml += "<figure><img style='width:" + item.itemAttribute.width + ";'  class='" + item.itemAttribute.class_style + "' " +
        "src='" + item.itemAttribute.src + "'></img>" +
        "<figcaption>" + item.itemAttribute.label + "</figcaption></figure>";

      innerHtml += "</div>";

      time = 2000;

    } else if (item.type == "API") {
      innerHtml = "<div style=\"" + style + ";\" class='searchia-docs-api " + item.itemAttribute.class_style + "'>" +
        "<div style='display: flex;padding: 4px;'>" +
        "<div style='display: table'><div  class='api-type'>" + item.itemAttribute.type + "</div></div>" +
        "<div  class='api-value'>" + item.itemAttribute.value + "</div>" +
        "</div>  ";
      innerHtml += "</div>";
    } else if (item.type == "SPACE") {
      innerHtml = "<div> ";
      innerHtml += "</div>";
    }

    // item.html_not_publish = innerHtml;
    // if (item.html_not_publish === innerHtml) {
    //   console.log("_______ok_______________"+item.priority);
    // }else {
    //   console.log("_______changed_______________"+item.priority);
    // }
    return innerHtml;
  }

}


